export default __webpack_public_path__ + "static/media/employees.d080b423.svg";